import { useQuery } from '@tanstack/react-query'
import { getHotlineCallsOptions } from '@/api/main/@tanstack/react-query.gen'
import type { GetHotlineCallsData } from '@/api/main/types.gen'
import dayjs from 'dayjs'

// Types for hotline calls
export interface HotlineCall {
  id: string
  phoneNumber: string
  callerName: string
  started: string
  acknowledged: string | null
  acknowledgedBy: string | null
  recording: {
    url: string
    size: string
  } | null
}

export interface BillingPeriod {
  id: string
  name: string
  startDate: string
  endDate: string
}

export function useHotlineCalls(startDate: Date, endDate: Date) {
  const options: Omit<GetHotlineCallsData, 'url'> = {
    path: {
      starting_from: dayjs(startDate).format('YYYY-MM-DD'), // Format as YYYY-MM-DD
      ending_at: dayjs(endDate).format('YYYY-MM-DD'), // Format as YYYY-MM-DD
    },
  }

  return useQuery(getHotlineCallsOptions(options as GetHotlineCallsData))
}
